import { Link } from "react-router-dom";
import { Alert, Colors, useFeatureFlags } from "swing-components";

import { createDocumentsUrl, createMyDocumentsUrl } from "~pages";
import { ExpiringDocumentsDetail, translate as t } from "~utils";

type ExpiringDocumentsBannerProps = ExpiringDocumentsDetail;

export function ExpiringDocumentsBanner(props: ExpiringDocumentsBannerProps) {
  const { status, expirationDate } = props;
  const { flags } = useFeatureFlags();
  const isDocumentsV2 = flags.myDocumentsV2;
  const isExpiringV2 = flags.expiringDocumentBannerV2;
  const url = isDocumentsV2 ? createDocumentsUrl() : createMyDocumentsUrl();

  let message = undefined;
  let isExpiring = false;

  switch (status) {
    case "DOC_EXPIRED":
      message = t(status);
      break;
    case "DOC_EXPIRING":
      message = t(status);
      isExpiring = true;
      break;
    case "MRT_EXPIRED":
      message = t(status);
      break;
    case "MRT_EXPIRING":
      message = t(status, { expirationDate });
      isExpiring = true;
      break;
    default:
      message = undefined;
      break;
  }

  const color = isExpiring ? Colors.black : Colors.white200;
  const backgroundColor = isExpiring ? Colors.yellow400 : Colors.red500;

  if (!isExpiringV2 && status === "DOC_EXPIRED") {
    return (
      <div css={{ padding: "var(--spacing-lg)" }}>
        <Alert color="danger" title={t(status)} showIcon={true}>
          <span>
            {t("LABEL_UPDATE_IN")} <Link to={url}>{t("SETTINGS_DOCUMENTS")}</Link>.
          </span>
        </Alert>
      </div>
    );
  }

  if (!message) {
    return null;
  }

  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        padding: "var(--spacing-lg)",
        width: "100%",
        fontWeight: "var(--swing-font-semibold)",
        color,
        backgroundColor,
      }}
    >
      <span>
        {`${message} ${t("LABEL_UPDATE_IN")}`}{" "}
        <Link
          css={{
            color,
            "&:visited": { color },
            "&:hover": { color },
          }}
          to={url}
        >
          {t("SETTINGS_DOCUMENTS")}
        </Link>
        .
      </span>
    </div>
  );
}
